export default "__VITE_ASSET__C$OYhKHG__"